export const PENDING_ITEM_ATTEMPT = "PENDING_ITEM_ATTEMPT";
export const PENDING_ITEM_SUCCESS = "PENDING_ITEM_SUCCESS";
export const PENDING_ITEM_FAILED = "PENDING_ITEM_FAILED";
/////////////////////////////
export const PENDING_UPDATE_SUCCESS = "PENDING_UPDATE_SUCCESS";
export const PENDING_UPDATE_FAILED = "PENDING_UPDATE_FAILED";